import * as types from './types';
import { loading, success, error } from 'State/actions';

export const getProductLicenses = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PRODUCT_LICENSES_FETCHING, true));
    try {
      const response = await MPWWebApi.getGeneric('Product/GetProductLicenses');
      dispatch(success(types.PRODUCT_LICENSES_FETCHED, response.data.Data));
    } catch (ex) {
      dispatch(error(types.PRODUCT_LICENSES_FETCH_ERROR, ex));
    }

    dispatch(loading(types.PRODUCT_LICENSES_FETCHING, false));
  };
};



// WEBPACK FOOTER //
// ./src/state/product/actions.js